import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import SurveyTemplateList from 'components/survey-templates';
import CustomSurveyList from 'components/customSurvey/CustomSurveyList';
import 'assets/scss/formvalidate.css';
import SurveyApi from 'apis/Survey';
import Loading from 'utils/Loading';
import {
  ROUTES,
  insertCustomSurveyIdtoUrl,
  insertIdtoUrl,
  ONBOARDING_ROUTES,
  isOnboardingRoute,
} from 'constants/Routes';
import {
  getQuestionAttributes,
  removeQuestionAttributes,
  removeSelectedTemplates,
} from 'constants/localStorageManager';
import { canAddSurvey } from 'utils/plansHelper';
import Toaster from 'components/Toaster';
import CustomizeSurveyModal from 'components/Onboarding/Modal/CustomizeSurvey';
import ShareSurveyModal from 'components/Onboarding/Modal/ShareSurvey';
import UpgradeSubscription from 'components/subscriptionFeature/upgradeSubscription';

import CustomSurveyModal from './CustomSurveyModal';
import CustomSurveyForm from './CustomSurveyForm';

class BusinessCustomSurveys extends Component {
  constructor() {
    super();
    this.state = {
      showSurveyList: true,
      wizardStep: 1,
      custom_survey_name: '',
      customSurveys: [],
      customSurveyId: '',
      modalToggle: false,
      toDeleteCustomSurvey: {},
      isFetchingSurveys: false,
      isUpgradeModalVisible: false,
      isSavingSurvey: false,
    };
    this.onCancel = this.onCancel.bind(this);
    this.resetState = this.resetState.bind(this);
    this.saveCustomSurvey = this.saveCustomSurvey.bind(this);
    this.fetchCustomSurveys = this.fetchCustomSurveys.bind(this);
    this.deleteCustomSurvey = this.deleteCustomSurvey.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.confirmDeleteCustomSurvey = this.confirmDeleteCustomSurvey.bind(this);

    this.onAddSurvey = this.onAddSurvey.bind(this);
    this.selectDisplay = this.selectDisplay.bind(this);
    this.hideSurveyList = this.hideSurveyList.bind(this);
    this.onWizardStepClick = this.onWizardStepClick.bind(this);
  }

  componentDidMount() {
    removeQuestionAttributes();
    removeSelectedTemplates();
    this.fetchCustomSurveys();
  }

  onCancel(e) {
    const { history, editId } = this.props;

    e.preventDefault();
    removeQuestionAttributes();
    removeSelectedTemplates();

    this.resetState();
    history.push(insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, editId));
  }

  onAddSurvey() {
    const { customSurveys } = this.state;
    const surveyLength = customSurveys.length;
    if (!canAddSurvey(surveyLength)) {
      this.setState({ isUpgradeModalVisible: true });
      return;
    }
    const { match, history, editId } = this.props;
    this.resetState();
    if (match.path === ONBOARDING_ROUTES.STEP_ONE)
      history.push(insertIdtoUrl(ONBOARDING_ROUTES.STEP_TWO, editId));
    else history.push(insertIdtoUrl(ROUTES.CUSTOM_SURVEY_ADD, editId));
  }

  onWizardStepClick(step) {
    this.setState({ wizardStep: step, showSurveyList: step === 1 });
  }

  toggleUpgradeModal = () => {
    this.setState(({ isUpgradeModalVisible }) => ({
      isUpgradeModalVisible: !isUpgradeModalVisible,
    }));
  };

  collectSurveyName = name => {
    this.setState({
      custom_survey_name: name,
    });
  };

  cancelDelete() {
    this.setState({
      modalToggle: false,
    });
  }

  deleteCustomSurvey(toDeleteCustomSurvey, customSurveyId) {
    this.setState({
      modalToggle: true,
      toDeleteCustomSurvey,
      customSurveyId,
    });
  }

  confirmDeleteCustomSurvey() {
    const { customSurveyId } = this.state;

    SurveyApi.delete(customSurveyId)
      .then(() => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully deleted custom survey'
        );
        this.cancelDelete();
        this.fetchCustomSurveys();
      })
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Error while deleting custom survey'
        )
      );
  }

  fetchCustomSurveys() {
    const { editId } = this.props;
    this.setState({ isFetchingSurveys: true });
    SurveyApi.getAll(editId)
      .then(({ data }) => {
        this.setState({ customSurveys: data });
      })
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Error while fetching data'
        )
      )
      .then(() => this.setState({ isFetchingSurveys: false }));
  }

  saveCustomSurvey(values) {
    const {
      customSurveyName,
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      phone,
      isSoonoSurveyPaused,
      rewardAttributes,
      international,
      customTerms,
      is_survey_recurring,
      recurring_frequency,
      max_recurring_allowed,
      limit_voucher_per_customer,
    } = values;
    const { editId, history, match } = this.props;
    this.setState({ isSavingSurvey: true });

    SurveyApi.addNew(
      editId,
      customSurveyName,
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      phone,
      isSoonoSurveyPaused,
      rewardAttributes,
      getQuestionAttributes() || [],
      international,
      customTerms,
      is_survey_recurring,
      recurring_frequency,
      max_recurring_allowed,
      limit_voucher_per_customer
    )
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully added custom survey'
        );
        removeQuestionAttributes();
        removeSelectedTemplates();
        if (match.path == ONBOARDING_ROUTES.STEP_TWO) {
          this.resetState();
          history.push({
            pathname: ONBOARDING_ROUTES.STEP_THREE,
            state: { createdSurvey: data },
          });
        } else
          history.push(
            insertCustomSurveyIdtoUrl(
              ROUTES.CUSTOM_SURVEY_QUESTIONS,
              data.business_id,
              data.id
            )
          );
      })
      .catch(e =>
        Toaster.getErrorToaster('exclamation-triangle', e.response.data.error)
      )
      .then(() => this.setState({ isSavingSurvey: false }));
  }

  resetState() {
    this.setState({
      showSurveyList: true,
      wizardStep: 1,
      custom_survey_name: '',
      customSurveyId: '',
      modalToggle: false,
    });
  }

  hideSurveyList() {
    this.setState({ showSurveyList: false, wizardStep: 2 });
  }

  selectDisplay() {
    const { history, location, match, editId, setModalStatus } = this.props;
    const { createdSurvey } = location.state || {};
    const {
      customSurveys,
      wizardStep,
      custom_survey_name,
      showSurveyList,
      rewards,
      isFetchingSurveys,
      isSavingSurvey,
    } = this.state;

    const isOnboarding = isOnboardingRoute(match.path);
    const hideAddSurvey = customSurveys.length == 0;
    if (isFetchingSurveys) return <Loading />;
    if (
      match.path === ROUTES.CUSTOM_SURVEY_LIST ||
      match.path === ONBOARDING_ROUTES.STEP_ONE ||
      match.path === ONBOARDING_ROUTES.STEP_THREE ||
      !canAddSurvey(customSurveys.length)
    ) {
      return (
        <div>
          <ShareSurveyModal
            path={match.path}
            history={history}
            createdSurvey={createdSurvey}
            setModalStatus={setModalStatus}
          />
          <button
            className={`btn btn-add btn-light btn-add-new ${
              hideAddSurvey ? 'd-none' : ''
            }`}
            onClick={this.onAddSurvey}
            name="addCustomSurvey"
          >
            <FontAwesomeIcon icon="plus" /> Add Survey
          </button>

          <Collapse className="collapse" isOpen>
            <CustomSurveyList
              editId={editId}
              customSurveys={customSurveys}
              rewards={rewards}
              deleteCustomSurvey={this.deleteCustomSurvey}
              isDisabled={isOnboarding}
              onAddSurvey={this.onAddSurvey}
            />
          </Collapse>
        </div>
      );
    }
    if (
      match.path === ROUTES.CUSTOM_SURVEY_ADD ||
      match.path === ONBOARDING_ROUTES.STEP_TWO
    ) {
      return (
        <div>
          {wizardStep == 2 && (
            <CustomizeSurveyModal
              path={match.path}
              setModalStatus={setModalStatus}
            />
          )}
          <Collapse className="collapse" isOpen={!showSurveyList}>
            <CustomSurveyForm
              defaultCustomSurveyName={custom_survey_name}
              addNewSurvey={this.saveCustomSurvey}
              isSavingSurvey={isSavingSurvey}
              addForm
            />
          </Collapse>

          <Collapse className="collapse" isOpen={showSurveyList}>
            <SurveyTemplateList
              showSurveyList={showSurveyList}
              collectSurveyName={this.collectSurveyName}
              hideSurveyList={this.hideSurveyList}
              onCancel={this.onCancel}
            />
          </Collapse>
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      modalToggle,
      toDeleteCustomSurvey,
      isUpgradeModalVisible,
    } = this.state;
    return (
      <div>
        <CustomSurveyModal
          modalToggle={modalToggle}
          cancelDelete={this.cancelDelete}
          confirmDeleteCustomSurvey={this.confirmDeleteCustomSurvey}
          toDeleteCustomSurvey={toDeleteCustomSurvey}
        />
        <UpgradeSubscription
          isUpgradeModalVisible={isUpgradeModalVisible}
          toggleUpgradeModal={this.toggleUpgradeModal}
          type="customSurveys"
        />
        {this.selectDisplay()}
      </div>
    );
  }
}

BusinessCustomSurveys.defaultProps = {
  setModalStatus: () => {},
};

BusinessCustomSurveys.propTypes = {
  match: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  editId: PropTypes.string.isRequired,
  setModalStatus: PropTypes.func,
};

export default withRouter(BusinessCustomSurveys);



// WEBPACK FOOTER //
// ./src/components/customSurvey/BusinessCustomSurveys.js